// @Core
import { cookies } from '@openbank/cf-ui-architecture-core';
// Enumerations
import { AppInformationNeedEnumeration } from 'enumerations/app-information-need.enumeration';
import { StorageCookiesEnum } from '@openbank/ziniaweb-ui-core-models';

const isQueryParamTokenOrAccessToken = (token: string): boolean =>
  Boolean(token || cookies.getCookie(StorageCookiesEnum.ACCESS_TOKEN));

const translationsHasBeenLoaded = (informationFlags: AppInformationNeedEnumeration[]): boolean =>
  informationFlags.includes(AppInformationNeedEnumeration.TRANSLATIONS) &&
  !informationFlags.includes(AppInformationNeedEnumeration.AUTHORIZATION_DATA);

export { isQueryParamTokenOrAccessToken, translationsHasBeenLoaded };
